import React from "react";
import Loading from "../../common/Loading";
import Header from "../../common/Header";
import BasicInfoForm from "./BasicInfoForm";

import logoBlack from "../../../assets/tomo_logo_black.svg";

const BasicInfoMobile = ({ loading, email, referralCode, _completeStep, createUserError }) => {

  return (
    <>
      {loading ? <Loading showBackdrop/> : null}
      <div
        className="stepContainer md:stepContainer-mobile sm:stepContainer-mobile"
        style={{ display: "block" }}
      >
        <Header className="md:hidden" />
        <div className="innerStepContainer xl:innerStepContainer-desktop lg:innerStepContainer-desktop md:innerStepContainer-mobile sm:innerStepContainer-mobile">
          <div id="stepHeader" className="md:pt-8 md:pb-3 md:py-8 w-full">
            <img
              src={logoBlack}
              style={{ padding: 0 }}
              className="hidden md:block mx-auto mt-12 w-auto"
              alt=''
            />
          </div>

          <div className="outerStack-mobile sm:outerStack xl:outerStack-mobile sm:outerStack-desktop lg:outerStack-mobile sm:outerStack-desktop md:outerStack-mobile sm:outerStack-mobile sm:outerStack-mobile sm:outerStack-mobile">
            <div className="innerStack">
              <div className="stepDescriptionText2">Create your account</div>
              <BasicInfoForm
                email={email}
                referralCode={referralCode}
                _completeStep={_completeStep}
                loading={loading}
              />
              {createUserError && <div className="errorText mb-4">{createUserError}</div>}
            </div>
          </div>
          <div className="font-open-sans">
            <span className="text-gray-600">Already have an account?</span>{" "}
            <a className="underline text-gray-600" href="/register/login">
              Sign in
            </a>
          </div>
          <div className="mt-4">
            <span className="font-open-sans text-gray-600">
              <i className="far fa-solid fa-shield-halved mr-2 text-purple-400" />
              Protected with Bank Level Security.
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicInfoMobile;